import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectDecipherLocaleMappings,
  selectDecipherQualificationsByLocale,
  selectDecipherSavingLocale,
  selectIsDecipherLoading,
} from './decipher-mapping.selectors';

@Injectable({ providedIn: 'root' })
export class DecipherMappingSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly localeMappings = this._store.selectSignal(
    selectDecipherLocaleMappings,
  );
  public readonly qualificationsByLocale = this._store.selectSignal(
    selectDecipherQualificationsByLocale,
  );
  public readonly isLoading = this._store.selectSignal(selectIsDecipherLoading);
  public readonly savingLocale = this._store.selectSignal(
    selectDecipherSavingLocale,
  );
}
